import { stateViewsInfo } from '../../info/stateViewsInfo';

export const getStateView = (launcherState: [string | null, string | null]): keyof typeof stateViewsInfo | null => {
  if (!launcherState) return null;

  for (const [stateView, info] of Object.entries(stateViewsInfo)) {
    if (info.significantLauncherState[0] === launcherState[0] && 
        info.significantLauncherState[1] === launcherState[1]) {
      return stateView as keyof typeof stateViewsInfo;
    }
  }
  
  return null;
}; 